"use strict";

exports.__esModule = true;
exports.yAxisMaxValueFactory = exports.yAxisFormatterFactory = void 0;
var _constants = require("../../constants");
var _valueFormatters = require("../../Echarts/Series/valueFormatters");
var _timeDefinitions = require("../../timeDefinitions");
var yAxisFormatterFactory = exports.yAxisFormatterFactory = function yAxisFormatterFactory(unit) {
  switch (unit) {
    case _constants.METRICS_MILLISECOND:
      return _valueFormatters.durationValueFormatter;
    case _constants.METRICS_FRACTIONAL_PERCENT:
      return _valueFormatters.percentageValueFormatter;
    default:
      return _valueFormatters.defaultValueFormatter;
  }
};
var yAxisMaxValueFactory = exports.yAxisMaxValueFactory = function yAxisMaxValueFactory(unit) {
  switch (unit) {
    case _constants.METRICS_MILLISECOND:
      return _timeDefinitions.HOUR_IN_MILLIS;
    case _constants.METRICS_FRACTIONAL_PERCENT:
      return 1;
    default:
      return undefined;
  }
};